import { BrowserRouter, Route, Routes as NRoutes } from "react-router-dom";
import "./App.css";
import Assureur from "./components/Assureur";
import AssureurDetails from "./components/AssureurDetails";
import Consultation from "./components/Consultation";
import Examen from "./components/Examen";
import Login from "./pages/Login/Login";
import Patient from "./components/Patient";
import PersonnelMedecin from "./components/PersonnelMedecin";
import Pharmacy from "./components/Pharmacy";
import Profile from "./components/Profile";
import Users from "./components/Users";
import RoleProtected from "./routes/RoleProtected";
import Appointments from "./pages/Appointments/Appointments";
import { Bilans } from "pages";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService/TermsOfService";
import Home from "./pages/Home/Home";
import QueueMedecin from "./pages/QueueMedecin/QueueMedecin";
import QueueSecretaire from "./pages/QueueSecretaire/QueueSecretaire";

/**
 * Table de routage unique. Tout écran authentifié est enveloppé dans
 * {@link RoleProtected}, qui contrôle le token puis la liste blanche de
 * droits par rôle (`STAFF_ROUTES_BY_ROLE` dans `constants/roles`) : les
 * chemins déclarés ici doivent rester identiques à ceux de `routePaths`.
 */
function Routes() {
  return (
    <div className="App">
      <BrowserRouter>
        <NRoutes>
          <Route path="/" element={<Login />} />
          <Route
            path="/users"
            element={
              <RoleProtected>
                <Users />
              </RoleProtected>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route
            path="/examen"
            element={
              <RoleProtected>
                <Examen />
              </RoleProtected>
            }
          />
          <Route
            path="/patient"
            element={
              <RoleProtected>
                <Patient />
              </RoleProtected>
            }
          />
          <Route
            path="/rendez-vous"
            element={
              <RoleProtected>
                <Appointments />
              </RoleProtected>
            }
          />
          <Route
            path="/pharmacy"
            element={
              <RoleProtected>
                <Pharmacy />
              </RoleProtected>
            }
          />
          <Route
            path="/profile"
            element={
              <RoleProtected>
                <Profile />
              </RoleProtected>
            }
          />
          <Route
            path="/consultation"
            element={
              <RoleProtected>
                <Consultation />
              </RoleProtected>
            }
          />
          <Route
            path="/assureur"
            element={
              <RoleProtected>
                <Assureur />
              </RoleProtected>
            }
          />
          <Route
            path="/assureur-details"
            element={
              <RoleProtected>
                <AssureurDetails />
              </RoleProtected>
            }
          />
          <Route
            path="/bilans"
            element={
              <RoleProtected>
                <Bilans />
              </RoleProtected>
            }
          />
          <Route
            path="/personnel-medecin"
            element={
              <RoleProtected>
                <PersonnelMedecin />
              </RoleProtected>
            }
          />
          <Route
            path="/file-attente/medecin"
            element={
              <RoleProtected>
                <QueueMedecin />
              </RoleProtected>
            }
          />
          <Route
            path="/file-attente/secretaire"
            element={
              <RoleProtected>
                <QueueSecretaire />
              </RoleProtected>
            }
          />
          {/* Routes publiques — accessibles sans connexion */}
          <Route path="/homepage" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="*" element={<p>Page introuvable.</p>} />
        </NRoutes>
      </BrowserRouter>
    </div>
  );
}

export default Routes;
